export default __webpack_public_path__ + "static/assets/b057370f6873a62241f61b0158839c6d.png";